import React from 'react';
import style from "./index.module.css";

const CompanyDescription = () => {
    return (
        <div>
            <div className={style.articleTitle}>
                机构简介
            </div>

            <div>
                <p>
                    湖州市两山生态资源认证有限公司（简称两山认证） 成立于 2023 年 7
                    月，并于2024年10月获得国家认证认可监督管理委员会(CNCA)批准，认证机构批准号：CNCA-R-2024-1388。
                    公司的全部收入来自于经国家认证认可管理部门批准范围内的认证收费。公司的财务实行独立核算， 配备相应的办公场所、 办公设备和交通工具等资源， 保证公司业务的运营。
                    公司设立市场客服部、综合部、审查部、技术评审部、 行政财务部等负责办理各项具体认证业务。
                </p>

                <p>
                    两山认证建立了一支专业、严谨、开拓的技术团队， 严格遵守认证行业相关法规要求，奉行“公正、
                    客观、权威”的宗旨。我们将以专业与真诚赢得您的信任；以专业的水准和严谨的作风保证审核公正、有效和权威；
                    我们将遵守职业道德及行业规范，以卓越服务为本，追求顾客满意，追求顾客与我们的共同发展。
                </p>

                <p>
                    公司注册地址： 浙江省湖州市西塞山路 1558 号联科商务中心 1 幢 E 区 612
                    邮编： 313000 电话： 13867281220
                </p>

            </div>
        </div>
    );
};

export default CompanyDescription;